import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { FormatDate } from '@utils/formDates';
import { Observable } from 'rxjs';
import { IPrevision, IPrevisionInterno, PrevisionInternoResponse } from '@models/IPrevisiones';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class PrevisionService {
  readonly SESSION_IDIOMA = KeysEstaticas.SESSION_IDIOMA;
  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  //7.1. GET: Funcion que devuelve la prevision de un centro en un periodo concreto
  getPrevisionByDates(
    startDate: string,
    endDate: string,
    centro = 1,
  ): Observable<IPrevision[]> {
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.sessionService.getIdioma();

    return this.http.get<IPrevision[]>(
      environment.API_URL + 'cliente/prevision/centro',
      {
        params: {
          idioma: idioma,
          startDate: String(startDate),
          endDate: String(endDate),
          centro: centro,
        },
      },
    );
  }

  //7.2. GET: Funcion que devuelve la prevision de un centro en un periodo concreto de un cliente interno
  getPrevisionInternaByDates(startDate: string, endDate: string, centro = 1): Observable<IPrevisionInterno[]> {
    return this.http.get<IPrevisionInterno[]>(
      environment.API_URL + 'cliente/prevision/prevision-interna/centro',
      {
        params: {
          startDate: String(startDate),
          endDate: String(endDate),
          centro: centro,
        },
      },
    );
  }

  //7.3. PUT: Funcion que modifica una previsión de un cliente // TODO  => MAALLLLLLLL
  // ! NO SE USA EN LA 1.0
  // putEditPrevision(previsionSemanal: IPrevision[],beginDate: string, endDate: string, centro: number = 1) {
  //   const user = this.sessionService.getUserInfo();
  //   const formattedEndpoint = EndpointHelper.formatEndpoint(ApiMethods.prevision_putEdit, user?.idOperador, centro,beginDate, endDate);
  //   return this.http.put<IPrevision[]>(environment.API_URL + formattedEndpoint, previsionSemanal);
  // }

  //7.6. PUT: Funcion que modifica la previsión de la semana de un cliente y centro
  putEditPrevisionAll(
    previsionSemanal: IPrevision[],
    startDate: string,
    endDate: string,
    centro = 1,
  ) {
    return this.http.put<void>(
      environment.API_URL + 'cliente/prevision/centro/semanal/all',
      previsionSemanal,
      {
        params: {
          startDate: String(startDate),
          endDate: String(endDate),
          centro: centro,
        },
      },
    );
  }


  // 7.4, 7.5, 7.7
  guardarPrevisionInterna(previsionInterna: IPrevisionInterno[], centro: number) {

    // ESTO SE HACE PORQUE SI NO LE RESTA UN DIA AL FECHA ENVIADA
    previsionInterna = previsionInterna.map(p => {
      return {
        ...p,
        fecha: FormatDate.formatDate(new Date(p.fecha!), '-')
      };
    });

    return this.http.post<PrevisionInternoResponse>(environment.API_URL + 'cliente/prevision/prevision-interna/guardarPrevisionInterna', previsionInterna, {
      params: {
        idCentro: String(centro),
      },
    });
  }

  //7.8. GET: Funcion que devuelve fecha de vencimiento para la previsión
  getDeadLine(date: string): Observable<Date> {
    return this.http.get<Date>(
      environment.API_URL + 'cliente/prevision/deadline',
      {
        params: {
          deadLine: date,
        },
      },
    );
  }

  //7.9 PREVISION. Obtener los festivos de un cliente
  // getFestivos(): Observable<Date[]> {
  //   const idOperador = this.userService.getOperadorId();
  //   return this.http.get<Date[]>(
  //     environment.API_URL + 'cliente/prevision/festivos',
  //     {
  //       params: {
  //         idOperador: String(idOperador),
  //       },
  //     },
  //   );
  // }

  calculateWeekRange(): { beginDate: string; endDate: string } {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const dayDiff = (dayOfWeek + 6) % 7;

    const diaInicio = new Date(today);
    diaInicio.setDate(today.getDate() - dayDiff);

    const diaFin = new Date(diaInicio);
    diaFin.setDate(diaInicio.getDate() + 6);

    return {
      beginDate: FormatDate.formatDate(diaInicio),
      endDate: FormatDate.formatDate(diaFin),
    };
  }

  getNextMonday(date: Date): Date {
    const day = date.getDay();
    const nextMonday = new Date(date);
    nextMonday.setDate(date.getDate() + ((7 - day + 1) % 7 || 7)); // Calcula el siguiente lunes
    return nextMonday;
  }

  getPrevMonday(date: Date): Date {
    const day = date.getDay();
    const prevMonday = new Date(date);
    prevMonday.setDate(date.getDate() - ((day + 6) % 7)); // Calcula el lunes anterior
    return prevMonday;
  }
}
